import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useLocation } from 'react-router-dom';

// Only show ads on content-rich pages (AdSense policy: no ads on screens without publisher-content)
const CONTENT_PAGES = ['/library', '/blog', '/phrase/', '/about', '/faqs', '/feedback', '/interpreter'];

const AdBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const adRef = useRef(null);
  const pushed = useRef(false);
  const [visible, setVisible] = useState(false);

  const isVip = user?.subscription_tier && user.subscription_tier !== 'free';
  const isAdmin = user?.role === 'admin';
  const shouldHide = isVip || isAdmin;

  // Only show on content-rich pages
  const isContentPage = CONTENT_PAGES.some(p => location.pathname.startsWith(p));

  useEffect(() => {
    if (shouldHide || pushed.current) return;

    // Only attempt to push ad if AdSense SDK is loaded
    if (!window.adsbygoogle) return;

    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // Ad blocker or not ready
    }

    // Poll to check if an ad actually rendered
    const checkAd = setInterval(() => {
      if (adRef.current) {
        const ins = adRef.current;
        const status = ins.getAttribute('data-ad-status');
        const height = ins.clientHeight;
        if (status === 'filled' || height > 10) {
          setVisible(true);
          clearInterval(checkAd);
        } else if (status === 'unfilled') {
          clearInterval(checkAd);
          // Ad slot exists but no ad served — keep hidden
        }
      }
    }, 500);

    // Stop checking after 8 seconds
    setTimeout(() => clearInterval(checkAd), 8000);

    return () => clearInterval(checkAd);
  }, [shouldHide]);

  if (shouldHide || !isContentPage) return null;

  // Render the ins tag but keep container at 0 height until ad fills
  return (
    <div
      style={{
        height: visible ? 'auto' : '0px',
        minHeight: visible ? '50px' : '0px',
        maxHeight: visible ? '90px' : '0px',
        overflow: 'hidden',
        transition: 'height 0.3s ease',
        margin: 0,
        padding: 0
      }}
      data-testid="ad-banner"
    >
      <ins
        className="adsbygoogle"
        ref={adRef}
        style={{ display: 'block', width: '100%', maxHeight: '90px' }}
        data-ad-client="ca-pub-7888737267155230"
        data-ad-slot="1769416851"
        data-ad-format="horizontal"
        data-full-width-responsive="false"
      />
    </div>
  );
};

export default AdBanner;
